import { createApi } from "@bandwith/api-client";

export type {
  ApiClient,
  FeedbackItem,
  InferResponseType,
  MusicianItem,
  SongDetail,
  SongListItem,
  SongRecording,
} from "@bandwith/api-client";

function getApiBaseUrl(): string {
  if (typeof window !== "undefined") {
    return `${window.location.origin}/api`;
  }
  return "http://localhost:3000/api";
}

export const api = createApi(getApiBaseUrl(), {
  fetch: (input, init) =>
    fetch(input, {
      ...init,
      credentials: "include",
    }),
});
